export default {
  jp: {
    title: {
      send: 'メール一斉配信',
      list: '宛先確認'
    },
    error: {
      from: {
        required: '配信元（From）は入力必須項目です。',
        invalid: '配信元（From）の書式に誤りがあります。'
      },
      services: {
        required: '利用サービスは入力必須項目です。',
        invalid: '利用サービスの入力内容に不備があります。'
      },
      groupLargeId: {
        invalid: '所属（大分類）の入力内容に不備があります。'
      },
      groupSmallId: {
        required: '所属（小分類）は入力必須項目です。',
        invalid: '所属（小分類）の入力内容に不備があります。'
      },
      companyId: {
        invalid: '会社の入力内容に不備があります。'
      },
      prefCd: {
        invalid: '都道府県の入力内容に不備があります。'
      },
      cc: {
        invalid: '宛先（Cc）の書式に誤りがあります。',
        overMaxCount: '宛先（Cc）はカンマ区切りで最大10個まで指定可能です。'
      },
      subject: {
        required: '件名は入力必須項目です。',
        maxLength: '件名は100文字以内で入力してください。'
      },
      body: {
        required: '本文は入力必須項目です。',
        invalid: '本文の入力内容に不備があります。'
      },
      sendMail: {
        sendTargetNotExist: '送信対象のアカウントが存在しません。宛先条件を確認してください。'
      }
    },
    label: {
      from: '配信元（From）',
      to: '宛先（To）',
      services: '利用サービス',
      group: '所属',
      company: '会社',
      prefCd: '都道府県',
      cc: '宛先（Cc）',
      subject: '件名',
      body: '本文',
      list: {
        group: '所属',
        companyName: '会社',
        mailAddress: 'メールアドレス',
        name: '氏名'
      }
    },
    ph: {
      from: '選択してください',
      services: '選択してください（複数可）',
      groupSmall: '選択してください（複数可）',
      companyId: '選択してください（複数可）',
      prefCd: '選択してください（複数可）',
      cc: '宛先（Cc）を入力してください（カンマで複数可能）',
      subject: '件名を入力してください',
      body: '本文を入力してください'
    },
    select: {
      other: 'その他'
    },
    button: {
      showAddress: '宛先確認',
      back: '戻る',
      send: '送信'
    },
    desc: {
      send: {
        text1: '※埋め込み可能文字列',
        text2: '{{COMPANY}}：会社名　　{{NAME}}：ユーザー名',
        text3: '※敬称等は含まれません。'
      },
      list: {
        noData: '検索条件に該当するアカウントは、ありません。',
        listCount1: '一覧件数',
        listCount2: '件'
      }
    }
  },
  en: {
  }

}
